import { render, staticRenderFns } from "./balloon-icon.vue?vue&type=template&id=6724ae65"
import script from "./balloon-icon.vue?vue&type=script&lang=js"
export * from "./balloon-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports